import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import Toggle from "react-toggle";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import Loading from "../../common/Loading";

import {
  TASK_DETAIL_COLUMNS,
  TASK_DETAIL_SUMMARY_COLUMNS,
  TASK_DETAIL_SUMMARY_SUB_COLUMNS
} from "./columns";

import "./TaskDetail.scss";

const TaskDetailList = ({
  data,
  loading,
  onPageSizeChange,
  defaultPageSize,
  onPageChange,
  onSortedChange,
  page,
  pageSize,
  count,
  summary,
  sorted
}) => {
  const getDefaultExpanded = useCallback(
    (value) => {
      const _expanded = {};
      data.forEach((row, index) => {
        _expanded[index] = value;
      });
      return _expanded;
    },
    [data]
  );

  const [isExpanded, setIsExpanded] = useState(true);
  const [expanded, setExpanded] = useState(getDefaultExpanded(true));

  useEffect(() => {
    setExpanded(getDefaultExpanded(isExpanded));
  }, [getDefaultExpanded, isExpanded]);

  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  if (!data || !data.length) {
    return (
      <div className="loading">
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <div style={{ display: "flex", marginBottom: 10 }}>
          <Toggle
            name="collapsed"
            onChange={() => setIsExpanded(!isExpanded)}
            checked={isExpanded}
            icons={{
              checked: <IoChevronUp />,
              unchecked: <IoChevronDown />
            }}
          />
          <span style={{ alignSelf: "center" }}>
            {isExpanded ? "Collapse All" : "Expand All"}
          </span>
        </div>
        <ReactTable
          className="-highlight"
          columns={TASK_DETAIL_SUMMARY_COLUMNS}
          data={summary}
          expanded={expanded}
          onExpandedChange={(newExpanded) => setExpanded(newExpanded)}
          SubComponent={({ original }) => (
            <ReactTable
              className="task-detail--task-list"
              data={original.tasks}
              columns={TASK_DETAIL_SUMMARY_SUB_COLUMNS}
              showPagination={false}
              showPageSizeOptions={false}
              pageSize={original.tasks.length}
            />
          )}
        />
      </div>
      <div className="content-wrapper">
        <ReactTable
          manual
          showPageSizeOptions
          showPagination
          className="-highlight"
          columns={TASK_DETAIL_COLUMNS}
          data={data}
          defaultPageSize={defaultPageSize}
          noDataText="No tasks found"
          pageSize={Math.min(pageSize)}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onSortedChange={onSortedChange}
          pages={Math.ceil(count / pageSize)}
          page={page}
          sorted={sorted}
        />
      </div>
    </React.Fragment>
  );
};
TaskDetailList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  defaultPageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageSizeChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number,
  summary: PropTypes.array,
  sorted: PropTypes.array
};
export default TaskDetailList;
